import React from "react";
import Lottie from "lottie-react";
import ComingSoon from "./ComingSoon.json";

const ComingSoonAnime = () => <Lottie animationData={ComingSoon} loop={true} />;

export default ComingSoonAnime;